import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";

export const hatimApi = createApi({
  reducerPath: "panelHatim",
  baseQuery: axiosBaseQuery(),
  // Sekmeye geri dönüşte ve bağlantı gelince yenile; bir bileşen mount olduğunda
  // cache 30 sn'den eskiyse tekrar çek. Böylece sayfa yenilemeye gerek kalmaz.
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: 30,
  tagTypes: ["MyHatimInstances"],
  endpoints: (builder) => ({
    getMyHatimInstances: builder.query({
      query: ({ monthKey }) => ({
        url: "/api/panel/hatim-instances/get-mine",
        method: "POST",
        data: monthKey ? { monthKey } : {},
      }),
      providesTags: (result, error, { monthKey }) => [
        { type: "MyHatimInstances", id: monthKey || "current" },
      ],
    }),
    updateMyHatimProgress: builder.mutation({
      query: ({ instanceId, completedAmount }) => ({
        url: "/api/panel/hatim-instances/update-my-progress",
        method: "POST",
        data: { instanceId, completedAmount },
      }),
      invalidatesTags: ["MyHatimInstances"],
    }),
    updateMyCompletedPageRanges: builder.mutation({
      query: ({ instanceId, ranges }) => ({
        url: "/api/panel/hatim-instances/update-my-page-ranges",
        method: "POST",
        data: { instanceId, ranges },
      }),
      invalidatesTags: ["MyHatimInstances"],
    }),
    getParticipationInfo: builder.query({
      query: ({ code }) => ({
        url: "/api/panel/hatim-instances/participation-info",
        method: "POST",
        data: { code },
      }),
    }),
    joinHatimByCode: builder.mutation({
      query: ({ code, pageRanges, amount }) => ({
        url: "/api/panel/hatim-instances/join-by-code",
        method: "POST",
        data: { code, pageRanges, amount },
      }),
      invalidatesTags: ["MyHatimInstances"],
    }),
    // Katılımcı hatimden ayrılır (şablondan ve süren dönemden çıkar, yöneticilere bildirim gider).
    leaveHatim: builder.mutation({
      query: ({ hatimTemplateId }) => ({
        url: "/api/panel/hatim-templates/leave",
        method: "POST",
        data: { hatimTemplateId },
      }),
      invalidatesTags: ["MyHatimInstances"],
    }),
  }),
});

export const {
  useGetMyHatimInstancesQuery,
  useUpdateMyHatimProgressMutation,
  useUpdateMyCompletedPageRangesMutation,
  useLazyGetParticipationInfoQuery,
  useJoinHatimByCodeMutation,
  useLeaveHatimMutation,
} = hatimApi;
